// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__f5RT8","calendarButtons":"ClockData_calendarButtons__24yo-"};